// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const RECAPCHA_API_KEY = "6LfBQd8UAAAAAA1-Gi4QJ3DHsbVNlaW1bhFTNciQ";
export const CRAFTY_CLICKS_API_KEY = "db697-93dd9-815a8-034dc";
export const GOOGLE_MAPS_API_KEY = "AIzaSyDaJRyIbZWNrm03nQJIm1UTWkk5d0-CwhM";
export const BASE_URL = "http://51.143.216.223:1002";
